import { Modal } from '@studiometa/ui';
/**
 * @typedef {{}} ZoomedGalleryProps
 */

/**
 * ZoomedGallery ZoomedGallery.
 * @augments {Base<ZoomedGalleryProps>}
 */
export default class ZoomedGallery extends Modal {
  isOpen = false;
  imagesAreDisplayed = false;
  zoom = 0;
  index = 0;
  isLoading = true;
  loadedImages = new Set(); // Track des images déjà chargées

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'ZoomedGallery',
    refs: [
      'close',
      'img[]',
      'plus',
      'minus',
      'counter',
      'thumbs[]',
      'wrapper',
      'prev',
      'next',
      'loader',
      'gallery',
    ],
  };

  /**
   *
   */
  mounted() {
    this.header = document.querySelector('#main-header');
    this.currentImage = this.$refs.img[0];
    this.currentThumb = this.$refs.thumbs[0];
    this.zoomedGallery = this.$refs.gallery;
  }

  /**
   *
   */
  onImgLoad() {
    this.handleImageLoad();
  }

  /**
   * Handle image load success
   */
  handleImageLoad() {
    this.isLoading = false;
    // Marquer l'image actuelle comme chargée
    this.loadedImages.add(this.index);

    if (this.$refs.loader) {
      this.$refs.loader.classList.add('hidden');
    }
    this.currentImage.classList.remove('hidden');
  }

  /**
   *
   */
  onDocumentGalleryupdated() {
    this.loadedImages.clear();
  }

  /**
   *
   */
  onPrevClick() {
    if (this.index === 0) {
      return;
    }

    this.index -= 1;
    this.setCurrentThumbs();
  }

  /**
   *
   */
  onNextClick() {
    if (this.index === this.$refs.img.length - 1) {
      return;
    }

    this.index += 1;
    this.setCurrentThumbs();
  }

  /**
   *
   */
  onCloseClick() {
    this.closeGallery();
  }

  /**
   *
   * @param {number} index index of element to be scrolled
   */
  openGallery(index) {
    this.header.classList.add('-translate-y-full');
    this.isOpen = true;
    this.index = index;

    this.setCurrentThumbs();

    document.body.classList.add('overflow-hidden');
    this.$el.classList.remove('opacity-0', 'pointer-events-none');
    this.$refs.loader.classList.add('hidden');
  }

  /**
   * OnThumbsClick
   * @param {object} props
   * @param {number} props.index
   */
  onThumbsClick({ index }) {
    this.index = index;
    this.setCurrentThumbs();
    this.setZoomLevel();
  }

  /**
   * Set current state for elements
   */
  setCurrentThumbs() {
    this.currentThumb.classList.add('opacity-50');
    this.currentThumb = this.$refs.thumbs[this.index];
    this.currentThumb.classList.remove('opacity-50');

    // Vérifier si l'image est déjà chargée
    const isImageLoaded = this.loadedImages.has(this.index);

    if (!isImageLoaded) {
      // Afficher le loader seulement si l'image n'est pas encore chargée
      if (this.$refs.loader) {
        this.$refs.loader.classList.remove('hidden');
      }
      this.isLoading = true;
    } else {
      // L'image est déjà chargée, pas besoin du loader
      this.isLoading = false;
      if (this.$refs.loader) {
        this.$refs.loader.classList.add('hidden');
      }
    }

    if (this.index === 0) {
      this.$refs.loader.classList.add('hidden');
    }

    this.currentImage.classList.add('hidden');
    this.currentImage = this.$refs.img[this.index];
    this.currentImage.classList.remove('hidden');

    this.setNavState();
  }

  /**
   *
   */
  setNavState() {
    if (this.index === 0) {
      this.$refs.prev.classList.add('opacity-20', 'pointer-events-none');
    } else {
      this.$refs.prev.classList.remove('opacity-20', 'pointer-events-none');
    }

    if (this.index === this.$refs.img.length - 1) {
      this.$refs.next.classList.add('opacity-20', 'pointer-events-none');
    } else {
      this.$refs.next.classList.remove('opacity-20', 'pointer-events-none');
    }
  }

  /**
   *
   */
  onPlusClick() {
    if (this.zoom === 2) {
      return;
    }
    this.zoomedGallery.classList.remove('pointer-events-none');

    this.zoom += 1;
    this.setZoomLevel();
  }

  /**
   *
   */
  onMinusClick() {
    if (this.zoom === 0) {
      return;
    }

    if (this.zoom === 1) {
      this.zoomedGallery.style.transform = `translate3d(0, 0, 0)`;
      this.zoomedGallery.classList.add('pointer-events-none');
    }

    this.zoom -= 1;
    this.setZoomLevel();
  }

  /**
   *
   */
  setZoomLevel() {
    const percent = this.zoom * 50;
    const scale = 1 + this.zoom * 0.6;
    this.$refs.counter.textContent = percent;
    this.$refs.wrapper.style.transform = `scale(${scale})`;
  }

  /**
   *
   */
  closeGallery() {
    this.isOpen = false;
    document.body.classList.remove('overflow-hidden');
    this.$el.classList.add('opacity-0', 'pointer-events-none');
    this.header.classList.remove('-translate-y-full');

    setTimeout(() => {
      this.zoom = 0;
      this.zoomedGallery.style.transform = 'translate3d(0, 0, 0)';
      this.zoomedGallery.classList.add('pointer-events-none');
      this.$refs.wrapper.style.transform = 'scale(1)';
      this.$refs.counter.textContent = '0';
      this.$refs.loader.classList.remove('hidden');
    }, 500);
  }

  /**
   * Close panel when type on Escape key
   * @param {object} props Props
   * @param {object} props.ESC Escape key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (ESC) {
      this.closeGallery();
    }
  }
}
